import { render, staticRenderFns } from "./LegacyNewsRedirect.vue?vue&type=template&id=6c81f3ab"
import script from "./LegacyNewsRedirect.vue?vue&type=script&lang=ts"
export * from "./LegacyNewsRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports